import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { dashboardService } from "./services/dashboard.service";
import { ILogin } from "domain/ILogin";
import { IPopoverState } from "./scenes/Carnets/domain/IPopoverState";

export const getMyLogins = createAsyncThunk(
  "Login/getMyLogins",
  async () => {
    try {
      return await dashboardService.getMyLogins();
    } catch (err) {
      setError(err);
    }
  }
);

interface loginState {
  loading: boolean;
  loginsPopover: IPopoverState;
  myLogins: ILogin[];
  error: any;
};

const initialState: loginState = {
  loading: false,
  loginsPopover: { isOpen: false },
  myLogins: [],
  error: null,
};

export const loginSlice = createSlice({
  name: "login",
  initialState: initialState,
  reducers: {
    setLoginsPopover: (state, action: PayloadAction<IPopoverState>) => {
      state.loginsPopover = action.payload;
    },
    setMyLogins: (state, action: PayloadAction<ILogin[]>) => {
      if (action.payload)
        state.myLogins = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMyLogins.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMyLogins.fulfilled, (state, action) => {
      if (action.payload) {
        state.myLogins = action.payload;
      }
      state.loading = false;
    });
    builder.addCase(getMyLogins.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const selectState = (state: RootState) => state.login;

export const {
  setLoginsPopover,
  setMyLogins,
  setError,
} = loginSlice.actions;

export default loginSlice.reducer;
